var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{directives:[{name:"tooltip",rawName:"v-tooltip.left",value:(_vm.tooltipText),expression:"tooltipText",modifiers:{"left":true}}],class:_vm.buttonClass,style:({ color: _vm.buttonColor }),attrs:{"icon":_vm.icon,"disabled":_vm.disabled},on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }